import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-expansion-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './expansion-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./expansion-panel.component.scss']
})
export class ExpansionPanelComponent {
  @Input() expanded: boolean = false;
  @Input() disabled: boolean = false;
  @Input() compact: boolean = false;
  @Output() expandedChange = new EventEmitter<boolean>();
  @Output() opened = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  public toggle(): void {
    if (this.disabled) {
      return;
    }

    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);

    if (this.expanded) {
      this.opened.emit();
    } else {
      this.closed.emit();
    }
  }

  public open(): void {
    if (!this.expanded && !this.disabled) {
      this.expanded = true;
      this.expandedChange.emit(true);
      this.opened.emit();
    }
  }

  public close(): void {
    if (this.expanded && !this.disabled) {
      this.expanded = false;
      this.expandedChange.emit(false);
      this.closed.emit();
    }
  }
}